import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=39370c7e&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=ts"
export * from "./order_detail.vue?vue&type=script&lang=ts"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=39370c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39370c7e",
  null
  
)

export default component.exports